import { AosLocation } from 'aos-services/src/services/common/types/AosLocation'
import { Box, CheckCircleGlyph, CloseGlyph, colors, Pressable, Text } from 'aos-ui-universal'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface TaskLocationFieldProps {
    location?: AosLocation
    onOpenOnMap(): void
    onClear?(): void
}

export const TaskLocationField = ({ location, onOpenOnMap, onClear }: TaskLocationFieldProps) => {
    const { t } = useTranslation()
    const hasLocation = !!location

    return (
        <Box>
            <Pressable
                accessibilityRole='button'
                onPress={onOpenOnMap}
                className='h-10 flex-row items-center justify-between gap-2 rounded border border-solid border-border-subtle bg-aos-bg-input px-3 hover:border-border-strong'
            >
                <Box className='flex-1 flex-row items-center gap-2'>
                    {hasLocation && <CheckCircleGlyph size={16} color={colors.status.success} />}
                    <Text size='body' tone={hasLocation ? 'default' : 'muted'} numberOfLines={1}>
                        {hasLocation
                            ? t('location.location-added', { ns: 'common' })
                            : t('location.select-on-map', { ns: 'common' })}
                    </Text>
                </Box>
                {hasLocation && onClear && (
                    <Pressable accessibilityRole='button' onPress={onClear}>
                        <CloseGlyph size={16} />
                    </Pressable>
                )}
            </Pressable>
            {hasLocation && (
                <Text size='caption' tone='muted' className='mt-2'>
                    {t('location.location-hint', { ns: 'common' })}
                </Text>
            )}
        </Box>
    )
}
